import React from 'react';
import moment from 'moment';
import TournamentRegisterResumeButton from './TournamentRegisterResumeButton';
import Timer from '../../../../../Timer/Timer';
import { useTranslation } from 'react-i18next';


const TournamentButtons = ({
  onLobby,
  onRegister,
  onDeposit,
  onResume,
  tournament,
  showBottom,
}) => {
  if (!tournament) return false;
  const { t } = useTranslation();
  const started = moment().isAfter(moment(tournament.startDate));

  return (
    <div className="tournaments-details__button-wrapper">
      <button className="tournaments__buttons__lobby tournaments__buttons__button secondary" onClick={onLobby}>
      {t('tournaments.tournamentLobby')}
      </button>
      <TournamentRegisterResumeButton tournament={tournament} onResume={onResume} onRegister={onRegister} />
      {showBottom && <div className="tournaments__buttons__deposit-row">
        <Timer withoutDate className="tournaments__timer" />
        <button className="tournaments__buttons__deposit tournaments__buttons__button primary" onClick={onDeposit}>
          {t('deposit')}
        </button>
      </div>}
    </div>
  );
}

export default TournamentButtons;